import { RoleName } from '@/api/entities/user-role-type';
import type { DocPage } from './types';

/**
 * A documentation page is visible when it has no `roles` (everyone), when the
 * user's role is listed, or when the user is an administrator (access to
 * everything). Same rule as the routes (RoleProtectedRoute: primary role).
 * Kept light (no import of the pages) so that it can be used everywhere.
 */
export const canSeeDocPage = (page?: DocPage, role?: RoleName | string) =>
  Boolean(page) &&
  (role === RoleName.ADMIN ||
    !page?.roles ||
    (role !== undefined && page.roles.includes(role as RoleName)));
